import api from './api';

export const getListRsProStatus = (params = {}) => {
  return api().get('/rs-pro-status', { params });
};

export const delRsProStatus = (list_id = []) => {
  return api().delete('/rs-pro-status', { data: { list_id } });
};

export const createRsProStatus = (values) => {
  return api().post(`/rs-pro-status`, values);
};

export const updateRsProStatus = (values) => {
  return api().put(`/rs-pro-status`, values);
};

export const getDetaiRsProStatus = (id) => {
  return api().get(`/rs-pro-status/${id}/detail`);
};

export const getErrorGroupOptions = () => {
  return api().get(`/rs-pro-status/error-group/options`);
};

export const getCountDuplicateCodeRsProStatus = (code) => {
  return api().get(`/rs-pro-status/${code}/count-duplicate-code`);
};
